import classNames from "classnames";
import { ButtonPrimary } from "components/Clickable/Buttons";
import { ErrorMessage } from "components/Input/ErrorMessage";
import { TextInputGroup } from "components/Input/Input";
import { writeCMSDataClientSide } from "helpers/api";
import { processServerSideErrors } from "helpers/forms";
import urls from "helpers/urls";
import { FormBase } from "interfaces";
import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";

import styles from "./password-recovery-form.module.scss";

interface Form extends FormBase {
    email: string;
}

export const PasswordRecoveryForm = () => {
    const {
        register,
        clearErrors,
        handleSubmit,
        setError,
        formState: { errors, isSubmitting },
    } = useForm<Form>();
    const [paragraph, setParagraph] = useState(
        "We will send you instructions to reset your password.",
    );

    const onSubmit: SubmitHandler<Form> = async (data) => {
        const response = await writeCMSDataClientSide(
            "POST",
            `/api/auth/password-request-request`,
            {},
            {
                ...data,
                continue_url: `${window.location.origin}${urls.changePassword}`,
            },
        );
        if (response.ok) {
            setParagraph(
                "A message has been sent to the email address you provided. Click the link inside to continue.",
            );
        } else {
            processServerSideErrors(response, data, setError);
        }
    };

    return (
        <>
            <h2 className={classNames(["h4", styles.heading])}>
                Forgot Password
            </h2>
            <p aria-live="polite">{paragraph}</p>
            <form
                noValidate
                onSubmit={(event) => {
                    clearErrors();
                    handleSubmit(onSubmit)(event);
                }}
                className={styles.form}
            >
                <TextInputGroup
                    {...register("email")}
                    type="text"
                    label="Email"
                    errorMessage={errors.email?.message}
                />
                <ButtonPrimary
                    className={styles.fullButtonMargin}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                >
                    Send
                </ButtonPrimary>
            </form>
            {errors.server?.message && (
                <ErrorMessage>{errors.server.message}</ErrorMessage>
            )}
        </>
    );
};
